import { Field, InputType, ObjectType } from 'type-graphql'
import { BaseEntity } from '../base/BaseEntity'
import { ChatSender } from './ChatSender'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { File } from '../file/File'
import { RelatedEntity } from '../base/RelatedEntity'
import { ChatMetadata } from './ChatMetadata'

// Enum must be declared before the class that uses it
export enum ChatMessageFormatEnum {
  html = 'html',
  text = 'text',
  unknown = 'unknown',
}

@ObjectType()
@InputType('ChatInput')
@modelOptions({ schemaOptions: { timestamps: true, strict: false, collection: 'chats' } })
export class Chat extends BaseEntity {
  @Field(() => ChatSender)
  @Prop({ type: ChatSender })
  sender: ChatSender

  @Field(() => String)
  @Prop({ type: String })
  subject: string

  @Field(() => String)
  lastMessageContent: string //A field resolver is needed

  @Field(() => [ChatMessage])
  messages: ChatMessage[] //A field resolver is needed

  @Field(() => String)
  @Prop({ type: String })
  externalId?: string

  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date //this is the external chat timestamp

  @Field(() => [ChatSender])
  @Prop({ type: [ChatSender] })
  collaborators: ChatSender[]

  @Field(() => ChatMetadata)
  @Prop({ type: ChatMetadata })
  metadata: ChatMetadata

  @Field(() => Boolean)
  isNew: boolean
}

//NOTE: It needs to be in this class to overcome the dependency on ChatMessage.chat field
@ObjectType()
@InputType('ChatMessageInput')
@modelOptions({ schemaOptions: { timestamps: true, strict: false, collection: 'chatmessages' } })
export class ChatMessage extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  externalId: string

  @Field(() => String)
  @Prop({ type: String })
  content: string

  @Field(() => String)
  @Prop({ type: String })
  plainContent: string

  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date //this is the external chat timestamp

  @Field(() => ChatSender)
  @Prop({ type: ChatSender })
  sender: ChatSender

  @Field(() => [File])
  @Prop({ type: [File] })
  attachments: File[]

  @Field(() => Boolean)
  @Prop({ type: Boolean })
  isPublic: boolean

  @Field(() => Boolean)
  @Prop({ type: Boolean, default: true })
  isUnread: boolean

  @Field(() => Chat)
  @Prop({ type: RelatedEntity })
  chat: Chat

  @Field(() => String)
  @Prop({ type: String })
  format: ChatMessageFormatEnum
}
